// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"89d3fea6","167":"a16e8e46","195":"f595dd9e","203":"35ffffad","249":"8c10fa53","293":"66784c58","303":"d3b7f674","345":"c4c75f8d","453":"01d90ec0","490":"ba1b2914","724":"df5f8ca7","982":"1b16f5b5","987":"bad75ca2"}[chunkId] + ".chunk.js";
};